import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Layout, Menu, Icon, Modal } from "antd";
import { connect } from "react-redux";
// import axios from 'axios';

import {
  AUTH_LOGOUT,
  RESET_ORDER_DETAIL,
  MENU_CHANGE,
  TOGGLE_MENU,
} from "../../ActionTypes/ActionTypes";

import "antd/dist/antd.css";
import "./Admin.css";
import Logo from "../../assets/caredose.png";

const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu;
const { confirm } = Modal;

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hospital:
        window.location.port !== process.env.REACT_APP_HOSPITAL_PORT &&
        window.location.hostname !== process.env.REACT_APP_HOSPITAL_URL,
    };
  }

  componentDidMount = () => {
    const { loggedIn, history } = this.props;
    if (loggedIn !== true) {
      history.push("/login");
    } else if (history.location.pathname === "/") {
      if (!this.state.hospital) {
        history.push("/allUsers");
      } else {
        history.push("/allOrders");
      }
    }
  };

  toggle = () => {
    const { toggelMenu } = this.props;
    toggelMenu();
  };

  select = (value) => {
    const { changeMenu, history } = this.props;
    changeMenu(value.key);
    history.push(value.key);
  };

  showConfirm = () => {
    const { resetOrderDetail, logOut, history } = this.props;
    confirm({
      title: "You will be logged Out",
      onOk: () => {
        resetOrderDetail();
        logOut();
        history.push("/login");
      },
      onCancel: () => {},
    });
  };

  handleLogOut = () => {
    this.showConfirm();
  };

  render() {
    const { collapsed, menu, children } = this.props;

    return (
      <Layout style={{ height: "100vh" }}>
        <Sider
          style={{
            overflow: "auto",
            height: "100%",
            position: "relative",
            left: 0,
          }}
          trigger={null}
          collapsible
          collapsed={collapsed}
        >
          <div className="row logo  align-self-center">
            <a className={collapsed ? "d-flex" : "d-flex ml-3"}>
              <img
                alt="Logo"
                className={collapsed ? "ml-2" : ""}
                src={Logo}
                style={{ height: "32px", width: "32px" }}
              />
              <div className={collapsed ? "d-none" : ""}>
                <p
                  style={{ textDecoration: "none" }}
                  className="ml-2 text-light lead"
                >
                  CareWare
                </p>
              </div>
            </a>
          </div>

          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={[menu]}
            onClick={this.select}
          >
            <Menu.Item key="/allUsers">
              <Icon type="user" />
              <span>Users</span>
            </Menu.Item>
            {this.state.hospital && (
              <SubMenu
                key="0"
                title={
                  <span>
                    <Icon type="bars" />
                    <span>Orders</span>
                  </span>
                }
              >
                <Menu.Item key="/inCompleteOrders">
                  <Icon type="book" />
                  <span className="text-light"> Incomplete Order</span>
                </Menu.Item>

                <Menu.Item key="/allOrders">
                  <Icon type="book" />
                  <span className="text-light"> All Order</span>
                </Menu.Item>

                <Menu.Item key="/addIncompleteOrder">
                  <Icon type="user-add" />
                  <span className="text-light">New Incomplete Order</span>
                </Menu.Item>

                <Menu.Item key="/addOrder">
                  <Icon type="user-add" />
                  <span className="text-light"> New Order</span>
                </Menu.Item>
              </SubMenu>
            )}
            {this.state.hospital && (
              <Menu.Item key="/managePartners">
                <Icon type="team" />
                <span className="text-light"> Partners</span>
              </Menu.Item>
            )}
            {this.state.hospital && (
              <Menu.Item key="/allMedicines">
                <Icon type="medicine-box" />
                <span>Medicines</span>
              </Menu.Item>
            )}
            {this.state.hospital && (
              <Menu.Item key="/doctors">
                <Icon type="alert" />
                <span>Doctors</span>
              </Menu.Item>
            )}
            <Menu.Item key="/refillManagementSystem">
              <Icon type="phone" />
              <span>Refill Management</span>
            </Menu.Item>
            {this.state.hospital && (
              <Menu.Item key="/inventory">
                <Icon type="down-circle" />
                <span>Inventory</span>
              </Menu.Item>
            )}
            {this.state.hospital && (
              <Menu.Item key="/dispatching">
                <Icon type="up-circle" />
                <span>Dispatching</span>
              </Menu.Item>
            )}
            {this.state.hospital && (
              <Menu.Item key="/analytics">
                <Icon type="pie-chart" />
                <span>Analytics</span>
              </Menu.Item>
            )}
          </Menu>
        </Sider>
        <Layout style={{ position: "relative", width: "100vw" }}>
          <Header
            style={{
              background: "#02152a",
              position: "fixed",
              zIndex: 1,
              width: "100%",
            }}
          >
            <Icon
              style={{ float: "left", paddingTop: 20, color: "white" }}
              className="trigger"
              type={collapsed ? "menu-unfold" : "menu-fold"}
              onClick={this.toggle}
            />

            <Icon
              style={{
                fontSize: "32px",
                color: "white",
                paddingTop: "15px",
                marginLeft: collapsed ? "90%" : "81%",
                cursor: "pointer",
              }}
              className="logout"
              type="logout"
              theme="outlined"
              onClick={this.handleLogOut}
            />
          </Header>

          <Content
            style={{
              margin: "80px 16px 24px 16px",
              padding: 24,
              background: "#fff",
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedIn: state.AppState.loggedIn,
  menu: state.AppState.menu,
  collapsed: state.AppState.collapsed,
});

const mapDispatchToProps = (dispatch) => ({
  logOut: () => dispatch({ type: AUTH_LOGOUT }),
  resetOrderDetail: () => dispatch({ type: RESET_ORDER_DETAIL }),
  changeMenu: (key) => dispatch({ type: MENU_CHANGE, key }),
  toggelMenu: () => dispatch({ type: TOGGLE_MENU }),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Admin));



// WEBPACK FOOTER //
// ./src/component/Admin/Admin.js